import { gql } from "@apollo/client";

export const VOUCHERS_FOR_SALE = gql`
  query ($lang: String) {
    vouchersForSale(lang: $lang) {
      ServiceGuid
      ServiceId
      VatRate
      VoucherTypeId
      ServiceName
      MinimumUnitPrice
      MaximumUnitPrice
      ValidUntil
      Prices {
        PriceId
        Price
        Value
        CurrencyId
      }
    }
  }
`;

export const CREATE_BASKET = gql`
  mutation ($lang: String, $currency: String, $affiliateId: String) {
    createBasket(lang: $lang, currency: $currency, AffiliateId: $affiliateId) {
      ... on CreateBasket {
        error {
          ErrorCode
          ErrorReason
        }
        basket {
          ShoppingBasketId
          ShoppingBasketNumber
          ValidUntil
          ValidUntilInUtc
          CanRenew
        }
      }
    }
  }
`;

export const ADD_VOUCHERS_TO_BASKET = gql`
  mutation ($input: AddVouchersToBasketInput!) {
    addVouchersToBasket(input: $input) {
      ... on AddVouchersToBasket {
        error {
          ErrorCode
          ErrorReason
        }
      }
    }
  }
`;

export const VOUCHER_FILE_URL = gql`
  query ($voucherCode: String!, $lang: String) {
    voucherFileUrl(voucherCode: $voucherCode, lang: $lang)
  }
`;
